(function(Way2web) {
    'use strict';

    Way2web.onDomReady = function() {
        Way2web.Header.initAffix();
        Way2web.Menu.initToggle();
        Way2web.Menu.dropdown();
        Way2web.Search.initSearchInline();
        Way2web.Readmore.init();
        Way2web.Togglr.init();
        Way2web.initFlippers();
        Way2web.initPopup();
        Way2web.preventClick();
        Way2web.openMenu();
        Way2web.closeMenu();
        Way2web.Spider.init();
        Way2web.Carousel.init();
        Way2web.Updates.initSearch();
        Way2web.Overview.initSearch();
        Way2web.Results.initSearch();

        Way2web.MapFacilitiesPartial.init();
        Way2web.MapFacilities.init();

        new window.Counters('js-counter', 2);
    };

    Way2web.onDomLoad = function() {
        Way2web.Menu.mimicMenu();
    };

    Way2web.preventClick = function() {
        $('.js-prevent-click').on('click', function(event) {
            event.preventDefault();
        });
    };

    Way2web.openMenu = function() {
        $('.js-open-menu').on('click', function() {
            $('.masthead__billboard-menu').addClass('u-display--block');
        });
    };

    Way2web.closeMenu = function() {
        $(document).mouseup(function(e) {
            var menu = $('.masthead__billboard-menu');

            // Check if masthead billboard menu has children and belong to the menu and remove class.
            if(e.target.id != menu.attr('class') && !menu.has(e.target).length) {
                $('.masthead__billboard-menu').removeClass('u-display--block');
            }
        });
    };

    Way2web.initPopup = function() {
        $('.js-video-popup').magnificPopup({
            type: 'iframe'
        });
    };

    Way2web.initFlippers = function() {
        $('.js-flipper').each(function() {
            Way2web.flipper($(this));
        });
    };

    Way2web.flipper = function($flipper) {
        if (!$flipper) {
            return false;
        }

        var $toggle = $flipper.find('.js-flipper-toggle');
        var $body = $flipper.find('.js-flipper-body');

        $toggle.on('click', function() {
            $flipper.toggleClass('is-active');
            $body.stop().slideToggle();
        });
    };

})(window.Way2web = window.Way2web || {});

$(document).ready(window.Way2web.onDomReady);
$(window).load(window.Way2web.onDomLoad);
